import { ConfirmModal, Table } from "components";
import { doFetchSupplyStorage, getSharedData } from "ducks/slices/ListData/SharedData.slice";
import { formLoadingState } from "ducks/slices/loadingSlice";
import { calcTotal, formatNumberToPrice, formatDateOfBirth, locdau } from "helpers";
import i18n, { languageKeys } from "../../../../i18n";
import { Button, Form, InputNumber, Select, Space, Tooltip } from "antd";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import style from "./sell.module.less";
import { ArrowDownCollapse, ArrowRightCollapse, CloseSquare } from "assets/svg";
import { doCancelPayment, doFetchSupplyList } from "ducks/slices/QlyVienPhi/BanThuoc.slice";
import { PrinterOutlined } from "@ant-design/icons";

const TableSell = ({
  form,
  receiptsList, setReceiptsList,
  receiptInfo, setReceiptInfo,
  expandedRows, setExpandedRows,
  patient,
  handlePrint,
  checkPermission
}) => {

  const cancelPaymentRef = useRef()

  const dispatch = useDispatch()
  const { paymentMethod, supplyStorage } = useSelector(getSharedData)
  const loading = useSelector(formLoadingState)

  const MIEN_GIAM = Form.useWatch("MIEN_GIAM", form)

  const isReviewing = (record) => record.TRANG_THAI_PHIEU === 'CHO_DUYET';


  useEffect(() => {
    !supplyStorage[0] && dispatch(doFetchSupplyStorage())
  }, [])


  // Thay đổi j đó
  const handleCommonChange = (value, record, keyVal) => {
    //
    const newArr = (
      receiptsList.map(item => {
        if (item.MA_PHIEU === record.MA_PHIEU) {
          return {
            ...item,
            CHI_TIET_PHIEU_VAT_TU: item.CHI_TIET_PHIEU_VAT_TU.map(i => {
              if (i.ID === record.ID) {
                if (keyVal === "MA_LO") {
                  return {
                    ...i,
                    ...value,
                    THANH_TIEN: i.MIEN_GIAM > 100
                      ? i.SO_LUONG * value.GIA_BAN - i.MIEN_GIAM
                      : i.SO_LUONG * value.GIA_BAN * (1 - (i.MIEN_GIAM ?? 0) / 100),
                  }
                }
                if (keyVal === "SO_LUONG") {
                  return {
                    ...i,
                    SO_LUONG: value,
                    TONG_MIEN_GIAM: i.MIEN_GIAM > 100
                      ? i.MIEN_GIAM
                      : value * i.GIA_BAN / 100 * i.MIEN_GIAM,
                    THANH_TIEN: i.MIEN_GIAM > 100
                      ? value * i.GIA_BAN - i.MIEN_GIAM
                      : value * i.GIA_BAN * (1 - (i.MIEN_GIAM ?? 0) / 100),
                  }
                }
                if (keyVal === "MIEN_GIAM") {
                  return {
                    ...i,
                    MIEN_GIAM: value,
                    THANH_TIEN: value > 100
                      ? i.SO_LUONG * i.GIA_BAN - value
                      : i.SO_LUONG * i.GIA_BAN * (1 - value / 100),
                    TONG_MIEN_GIAM: value > 100
                      ? value
                      : i.SO_LUONG * i.GIA_BAN / 100 * value,
                    MIEN_GIAM_PHAN_TRAM: value <= 100 ? value : 0,
                  }
                } else {
                  return { ...i, [keyVal]: value }
                }
              } else return i;
            })
          }
        } else return item;
      })
    )
    setReceiptsList(newArr);
    //
    const newInfo = newArr.find(i => i.ID === receiptInfo.ID)
    setReceiptInfo(newInfo)
    handleSetField(newInfo.CHI_TIET_PHIEU_VAT_TU)
  }


  // Sửa giá trị form
  const handleSetField = (arr) => {
    form.setFields([
      {
        name: "LIST_HINH_THUC_THANH_TOAN",
        value: [{
          BENH_NHAN_DUA: calcTotal(arr, "THANH_TIEN") - (
            MIEN_GIAM
              ? MIEN_GIAM > 100
                ? MIEN_GIAM
                : calcTotal(arr, "THANH_TIEN") / 100 * MIEN_GIAM
              : 0
          ),
          HINH_THUC_THANH_TOAN_ID: paymentMethod.find((i) => i.PHAN_LOAI_HINH_THUC === "TIEN_MAT")?.ID,
        }]
      },
      {
        value: calcTotal(arr, "THANH_TIEN") - (
          MIEN_GIAM
            ? MIEN_GIAM > 100
              ? MIEN_GIAM
              : calcTotal(arr, "THANH_TIEN") / 100 * MIEN_GIAM
            : 0
        ),
        name: "TIEN_KHACH_DUA",
      },
    ])
  }


  // Columns
  const columns = [
    {
      title: i18n.t(languageKeys.ma_thuoc_vt),
      dataIndex: 'MA_VAT_TU',
      onCell: (rc) => ({ colSpan: rc.CHI_TIET_PHIEU_VAT_TU ? 9 : 1 }),
      width: 110,
      render: (MA_VAT_TU, rc) => rc.CHI_TIET_PHIEU_VAT_TU
        ? (
          <Space size={10}>
            <label>{i18n.t(languageKeys.ma_phieu)}: {rc.MA_PHIEU}</label>
            {rc.TRANG_THAI_THANH_TOAN ? (
              <div
                className={style['action']}
                onClick={(e) => e.stopPropagation()}
              >
                <Button
                  icon={<PrinterOutlined className={style['print']} />}
                  type="link"
                  disabled={!checkPermission.IN}
                  onClick={() => handlePrint([rc.ID])}
                />
                <Tooltip title={i18n.t(languageKeys.huy_phieu)}>
                  <Button
                    icon={<CloseSquare className={style['delete']} />}
                    type="link"
                    disabled={!checkPermission.HUY}
                    onClick={() => cancelPaymentRef.current?.open(rc)}
                  />
                </Tooltip>
              </div>
            ) : <></>}
          </Space>
        )
        : MA_VAT_TU
    },
    {
      title: i18n.t(languageKeys.ten_thuoc_vtyt_hoa_chat),
      dataIndex: 'TEN_VAT_TU',
      onCell: (rc) => ({ colSpan: rc.CHI_TIET_PHIEU_VAT_TU ? 0 : 1 }),
      width: 200,
      // render: (TEN_VAT_TU, record) => (
      //   <div>
      //     <div>{TEN_VAT_TU}</div>
      //     {
      //       record.NONG_DO || record.HAM_LUONG
      //         ? <p style={{ marginBottom: -5 }}>{record.NONG_DO || record.HAM_LUONG}</p>
      //         : <></>
      //     }
      //   </div>
      // )
    },
    {
      title: i18n.t(languageKeys.field_Gia_ban),
      dataIndex: 'GIA_BAN',
      onCell: (rc) => ({ colSpan: rc.CHI_TIET_PHIEU_VAT_TU ? 0 : 1 }),
      width: 100,
      render: (money, record) => record.VAT_TU_TRONG_KHO_ID ? formatNumberToPrice(money) : undefined,
    },
    {
      title: i18n.t(languageKeys.sl),
      dataIndex: 'SO_LUONG',
      onCell: (rc) => ({ colSpan: rc.CHI_TIET_PHIEU_VAT_TU ? 0 : 1 }),
      width: 140,
      render: (value, record) =>
        isReviewing(record)
          ? (record.VAT_TU_TRONG_KHO_ID || record.ID) && (
            <Tooltip
              title={record.TONg_KHO >= 0 ? `${i18n.t(languageKeys.duoc_so_luong_toi_da)}: ${record.TON_KHO}` : null}
              placement="left"
              trigger="focus"
            >
              <InputNumber
                className={style.sl}
                placeholder={i18n.t(languageKeys.common_Nhap)}
                value={value}
                min={!!record.TON_KHO ? 1 : 0}
                max={record.TON_KHO}
                onChange={(val) => handleCommonChange(val, record, "SO_LUONG")}
                addonAfter={
                  <Tooltip title={record.TEN_DVT}>{record.TEN_DVT}</Tooltip>
                }
                status={!value && "error"}
                readOnly={!record.LO_VAT_TU?.[0]}
              />
            </Tooltip>
          )
          : `${value} ${record.TEN_DVT ?? ""}`
    },
    {
      title: i18n.t(languageKeys.field_Mien_giam),
      dataIndex: "MIEN_GIAM",
      onCell: (rc) => ({ colSpan: rc.CHI_TIET_PHIEU_VAT_TU ? 0 : 1 }),
      width: 140,
      render: (value, record) =>
        isReviewing(record)
          ? record.VAT_TU_TRONG_KHO_ID && (
            <InputNumber
              placeholder={i18n.t(languageKeys.common_Nhap)}
              value={value}
              min={0}
              max={record.SO_LUONG * record.GIA_BAN}
              formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              controls={false}
              addonAfter={value > 100 ? "đ" : "%"}
              onChange={(val) => handleCommonChange(val, record, "MIEN_GIAM")}
              readOnly={!record.SO_LUONG}
            />
          )
          : (record.MIEN_GIAM_PHAN_TRAM === "0" || !record.MIEN_GIAM_PHAN_TRAM)
            ? record.TONG_MIEN_GIAM > 0 ? `${formatNumberToPrice(record.TONG_MIEN_GIAM)} đ` : 0
            : `${record.MIEN_GIAM_PHAN_TRAM} %`
    },
    {
      title: 'VAT',
      dataIndex: 'VAT',
      onCell: (rc) => ({ colSpan: rc.CHI_TIET_PHIEU_VAT_TU ? 0 : 1 }),
      width: 60,
      render: (VAT, record) => record.VAT_TU_TRONG_KHO_ID ? `${VAT} %` : undefined
    },
    {
      title: i18n.t(languageKeys.thanh_tien),
      dataIndex: 'THANH_TIEN',
      onCell: (rc) => ({ colSpan: rc.CHI_TIET_PHIEU_VAT_TU ? 0 : 1 }),
      width: 110,
      render: (money, record) =>
        isReviewing
          ? money ? formatNumberToPrice(money) : undefined
          : formatNumberToPrice(record.SO_LUONG * record.GIA_BAN - record.TONG_MIEN_GIAM)
    },
    {
      title: i18n.t(languageKeys.field_ma_lo),
      dataIndex: 'MA_LO',
      onCell: (rc) => ({ colSpan: rc.CHI_TIET_PHIEU_VAT_TU ? 0 : 1 }),
      width: 180,
      render: (MA_LO, record) =>
        isReviewing(record)
          ? record.LO_VAT_TU && (
            <Select
              value={record.LO_ID}
              placeholder={i18n.t(languageKeys.common_Chon)}
              options={
                record.LO_VAT_TU?.map((i) => ({
                  ...i,
                  value: i.LO_ID || i.ID,
                  label: `${i.MA_LO} - ${formatDateOfBirth(i.HAN_SU_DUNG)}`
                }))
              }
              filterOption={(input, option) => (locdau(option?.label) ?? '').includes(locdau(input))}
              showSearch
              onChange={(_, opt) => handleCommonChange(opt, record, "MA_LO")}
              status={!MA_LO && "error"}
            />
          )
          : `${MA_LO} - ${formatDateOfBirth(record.HAN_SU_DUNG)}`,
    },
    {
      title: i18n.t(languageKeys.kho_duoc_vat_tu),
      dataIndex: "KHO_VAT_TU_ID",
      onCell: (rc) => ({ colSpan: rc.CHI_TIET_PHIEU_VAT_TU ? 0 : 1 }),
      width: 130,
      render: (ID) => supplyStorage.find((i) => i.ID === ID)?.TEN_KHO,
    },
  ];


  // HTML
  return (
    <>
      <Table
        className={style.table}
        columns={columns}
        dataSource={receiptsList}
        scroll={{ y: 'calc(100vh - 285px)' }}
        expandable={{
          expandRowByClick: true,
          expandedRowKeys: expandedRows,
          onExpand: (expanded, record) => setExpandedRows(
            !expanded
              ? expandedRows.filter(i => i !== record.ID)
              : [...expandedRows, record.ID]
          ),
          expandIcon: ({ expanded, onExpand, record }) =>
            record.CHI_TIET_PHIEU_VAT_TU
              ? (
                expanded
                  ? <ArrowDownCollapse onClick={(e) => onExpand(record, e)} />
                  : <ArrowRightCollapse onClick={(e) => onExpand(record, e)} />
              )
              : <></>,
          childrenColumnName: "CHI_TIET_PHIEU_VAT_TU"
        }}
        rowSelection={
          receiptsList.every(i => i.TRANG_THAI_THANH_TOAN)
            ? false
            : {
              checkStrictly: true,
              getCheckboxProps: (record) => {
                if (!record.CHI_TIET_PHIEU_VAT_TU || record.TRANG_THAI_PHIEU !== 'CHO_DUYET') return { disabled: true };
              },
              selectedRowKeys: [receiptInfo.ID],
              type: "radio",
              onSelect: (row) => {
                setReceiptInfo(row)
                handleSetField(row.CHI_TIET_PHIEU_VAT_TU)
              }
            }
        }
        showGap={false}
        loading={loading}
        rowKey={"ID"}
      />

      <ConfirmModal
        ref={cancelPaymentRef}
        danger
        content={i18n.t(languageKeys.cf_ban_co_chac_chan_muon_huy_thanh_toan)}
        width={410}
        onOk={({ ID }) => dispatch(doCancelPayment({
          data: { PHIEU_BAN_VAT_TU_ID: ID },
          setLoading: (bool) => cancelPaymentRef.current?.loading(bool),
          closeModal: () => {
            cancelPaymentRef.current?.close()
            dispatch(doFetchSupplyList(patient))
          }
        }))}
      />
    </>
  )
}

export default TableSell;